import { render } from "./index.vue?vue&type=template&id=7dee7e7c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7dee7e7c&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dee7e7c"]])

export default __exports__